module.exports = __webpack_public_path__ + "static/img/2-5.5833810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-5.jpg
// module id = PVrB
// module chunks = 1